import { Autoplay, Swiper, SwiperOptions } from 'swiper';
import SwiperCore, {
  Navigation,
  FreeMode,
  Lazy,
  Thumbs
} from 'swiper';

// install Swiper modules
SwiperCore.use([Navigation, FreeMode, Lazy, Thumbs, Autoplay]);

import Component from "../../../../base/Component";

export default class ProductDetailGallery extends Component {
    constructor(props) {
        super(props)
    }

    init() {

        const swiperParamsThumbs: SwiperOptions = {
            slidesPerView: 3,
            spaceBetween: 10,
            freeMode: true,
            lazy: true,
            watchSlidesProgress: true,
            cssMode: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
                pauseOnMouseEnter: true,
            },
            // Responsive breakpoints
            breakpoints: {
                640: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
                480: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                },
            }
        };

        // Function that actually builds the swiper
        const buildSwiperSlider = (sliderElm: HTMLElement) => {
            const thumbs = new Swiper(sliderElm.querySelector('[data-slider-pdthumbs]'), swiperParamsThumbs);
            const swiperParamsPreview: SwiperOptions = {
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                    loop: true,
                    effect: 'slide',
                    longSwipes: true,
                },
                thumbs: {
                    swiper: thumbs,
                },
                navigation: {
                    prevEl: sliderElm.querySelector('.slider-pdgallery__control-prev'),
                    nextEl: sliderElm.querySelector('.slider-pdgallery__control-next'),
                },
                cssMode: true
            };

            new Swiper(sliderElm.querySelector('[data-slider-pdprev]'), swiperParamsPreview);
        }

        // Get all of the swipers on the page
        const allSliders = document.querySelectorAll('[data-pdgallery]');

        // Loop over all of the fetched sliders and apply Swiper on each one.
        allSliders.forEach(slider => buildSwiperSlider(slider));
    }
}

